import React from 'react';
import PropTypes from 'prop-types';
import { PriceFreezeOfferProvider } from '@/providers/PriceFreezeOfferProvider';
import { LoginFunnelProvider } from '@/providers/login/LoginProvider';
import { PriceFreezeTrackingProvider } from '@/providers/tracking/PriceFreezeTrackingProvider';
import { PFSessionProvider } from './PriceFreezeSessionProvider';
import { PrimeUserProvider } from './PrimeUserProvider';
import { BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
import { BrokenFlowFlights } from '@/components/FunnelErrors';
import { SubscriptionsProvider } from '@/providers/SubscriptionsProvider';
import { PrimeCheckEntrypoint } from '@/providers/PrimeCheck';
import { UserInfoProvider } from '@/providers/UserInfoProvider';
import { PriceFreezeMultiOfferProvider } from '@/providers/PriceFreezeMultiOfferProvider';

export function PriceFreezeFunnelProvider({
  children,
  searchId,
  fareItineraryKey,
  segmentKeys,
  loginProps,
  page,
  skeleton,
}) {
  return (
    <>
      <BlockingErrorBoundary name="funnel_price_freeze">
        <LoginFunnelProvider loginProps={loginProps}>
          <PrimeCheckEntrypoint>
            <SubscriptionsProvider>
              <UserInfoProvider>
                <PriceFreezeOfferProvider
                  searchId={searchId}
                  fareItineraryKey={fareItineraryKey}
                  segmentKeys={segmentKeys}
                  skeleton={skeleton}
                >
                  <PriceFreezeMultiOfferProvider
                    searchId={searchId}
                    fareItineraryKey={fareItineraryKey}
                    segmentKeys={segmentKeys}
                  >
                    <PriceFreezeTrackingProvider page={page}>
                      <PFSessionProvider>
                        <PrimeUserProvider>{children}</PrimeUserProvider>
                      </PFSessionProvider>
                    </PriceFreezeTrackingProvider>
                  </PriceFreezeMultiOfferProvider>
                </PriceFreezeOfferProvider>
              </UserInfoProvider>
            </SubscriptionsProvider>
          </PrimeCheckEntrypoint>
        </LoginFunnelProvider>
      </BlockingErrorBoundary>
      <BrokenFlowFlights />
    </>
  );
}

PriceFreezeFunnelProvider.propTypes = {
  searchId: PropTypes.string.isRequired,
  fareItineraryKey: PropTypes.string.isRequired,
  segmentKeys: PropTypes.arrayOf(PropTypes.number).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  loginProps: PropTypes.shape({
    user: PropTypes.object.isRequired,
  }),
  skeleton: PropTypes.element,
};
